import { createFileRoute } from '@tanstack/react-router';
import { SkillsHeatmap } from '../features/parent/SkillsHeatmap';
import { RequireAuth, STATS_ROLES } from '../features/auth/RequireAuth';

export const Route = createFileRoute('/parent/skills')({
  component: () => <RequireAuth role={STATS_ROLES}>{(me) => <SkillsHeatmap me={me} />}</RequireAuth>,
});
